import { render, staticRenderFns } from "./XcCrumbs.vue?vue&type=template&id=f231a188&scoped=true&"
import script from "./XcCrumbs.vue?vue&type=script&lang=js&"
export * from "./XcCrumbs.vue?vue&type=script&lang=js&"
import style0 from "./XcCrumbs.vue?vue&type=style&index=0&id=f231a188&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f231a188",
  null
  
)

export default component.exports